import React, { useMemo } from 'react';
import { useTranslation, Translation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Label, Popup } from 'nallian-shared-ui/lib/components';
import { NoBreakSpan } from '../../../app/styles';

const JOIN_REQUEST_STATUS_OPTIONS = [
  {
    value: true,
    color: 'orange',
    key: 'potentialDuplicate',
    text: <Translation>{t => t('potentialDuplicate')}</Translation>,
  },
  { value: false, color: 'green', key: 'new', text: <Translation>{t => t('new')}</Translation> },
];

const JoinRequestStatus = ({ value }) => {
  const { t } = useTranslation();
  const statusOption = useMemo(() => JOIN_REQUEST_STATUS_OPTIONS.find(s => s.value === value), [
    value,
  ]);

  if (!statusOption) {
    return null;
  }

  const label = <Label round content={t(statusOption.key)} color={statusOption.color} />;

  if (value) {
    return (
      <Popup
        trigger={<NoBreakSpan>{label}</NoBreakSpan>}
        content={t('potentialDuplicateTooltip')}
        position="top center"
        on="hover"
      />
    );
  }

  return label;
};

JoinRequestStatus.propTypes = {
  value: PropTypes.bool.isRequired,
};

export default JoinRequestStatus;
